import React from 'react'

export const Loader = () => <p>Loading</p>

export default Loader
